/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import type { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Cart',
  definitions: {
    '16': {
      viewBox: '0 0 16 16',
      path: (
        <>
          <path
            fillRule="evenodd"
            d="M1.683 1.138a.55.55 0 0 0-.446 1.006l.964.427v7.646a2.55 2.55 0 0 0 1.396 2.274 1.61 1.61 0 0 0-.213.802 1.62 1.62 0 0 0 1.617 1.617 1.62 1.62 0 0 0 1.617-1.617c0-.184-.031-.361-.088-.526h3.401c-.057.165-.088.342-.088.526a1.62 1.62 0 0 0 1.617 1.617 1.62 1.62 0 0 0 1.617-1.617c0-.912-.771-1.626-1.669-1.626h-6.66a1.45 1.45 0 0 1-1.45-1.45v-.214a1.99 1.99 0 0 0 .901.214h8.356c.847 0 1.534-.687 1.534-1.533V5.424c0-.385-.286-.711-.668-.76L3.301 3.353v-.891c0-.369-.218-.704-.555-.853l-1.063-.471zm1.619 7.079V4.462l9.689 1.255v2.965c0 .239-.194.433-.433.433H4.201a.9.9 0 0 1-.9-.9zm1.7 5.594c.286 0 .517-.232.517-.517s-.232-.517-.517-.517-.517.232-.517.517.232.517.517.517zm6.978-.517c0 .286-.232.517-.517.517s-.517-.232-.517-.517.232-.517.517-.517.517.232.517.517z"
            fill="currentColor"
          />
        </>
      ),
    },
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.76004 2.08141C3.45709 1.94712 3.10265 2.08385 2.96837 2.3868C2.83409 2.68974 2.97081 3.04418 3.27376 3.17846L5.91006 4.34703V16.1998C5.91006 17.3867 6.70541 18.3879 7.79223 18.6994C7.60847 19.0194 7.50339 19.3903 7.50339 19.7858C7.50339 20.9922 8.48143 21.9703 9.6879 21.9703C10.8944 21.9703 11.8724 20.9922 11.8724 19.7858C11.8724 19.431 11.7878 19.096 11.6378 18.7998H16.4149C16.2648 19.096 16.1802 19.431 16.1802 19.7858C16.1802 20.9922 17.1583 21.9703 18.3648 21.9703C19.5712 21.9703 20.5493 20.9922 20.5493 19.7858C20.5493 18.5967 19.5549 17.5998 18.3648 17.5998H8.51006C7.73686 17.5998 7.11006 16.973 7.11006 16.1998V14.8864C7.35669 14.9952 7.62945 15.0556 7.91631 15.0556H19.0833C20.1879 15.0556 21.0833 14.1602 21.0833 13.0556V8.8034C21.0833 8.30186 20.7118 7.8779 20.2146 7.81205L7.11006 6.0766V4.28197C7.11006 3.84687 6.8536 3.45265 6.45582 3.27634L3.76004 2.08141ZM7.11631 13.0556V7.2879L19.8833 8.97866V13.0556C19.8833 13.4974 19.5251 13.8556 19.0833 13.8556H7.91631C7.47448 13.8556 7.11631 13.4974 7.11631 13.0556ZM9.6879 20.7703C10.2316 20.7703 10.6724 20.3295 10.6724 19.7858C10.6724 19.242 10.2316 18.8012 9.6879 18.8012C9.14417 18.8012 8.70339 19.242 8.70339 19.7858C8.70339 20.3295 9.14417 20.7703 9.6879 20.7703ZM19.3493 19.7858C19.3493 20.3295 18.9085 20.7703 18.3648 20.7703C17.821 20.7703 17.3802 20.3295 17.3802 19.7858C17.3802 19.242 17.821 18.8012 18.3648 18.8012C18.9085 18.8012 19.3493 19.242 19.3493 19.7858Z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
